import React, { useRef, useState } from "react";
import { AiFillEdit } from "react-icons/ai";
import "../../ReviewComponents/ABMOfDocuments/ABMOfDocuments.css";

const EditABM = ({ OpenForm, setTypeDocument, typeDocument, setFileId, id }) => {
  const downloadLinkRef = useRef(null);
  const [tipeButtonAMB] = useState({
    viewList: true,
    tipeForm: "Editar",
  });

  const handleClick = (e) => {
    e.preventDefault();
    handlerdowload(e);
    handleCreateClick(e);
  };

  const handlerdowload = async (e) => {
    e.preventDefault();
    OpenForm(tipeButtonAMB);
  };

  const handleCreateClick = (e) => {
    e.preventDefault();
    setTypeDocument(typeDocument);
    setFileId(id);
  };

  return (
    <button
      className="button_abm"
      type="button"
      onClick={(e) => handleClick(e)}
      ref={downloadLinkRef}
    >
      <i className="fa fa-refresh"></i>
      <AiFillEdit className="icon-list" />
    </button>
  );
};

export default EditABM;